import { intl } from '@xpeng/i18n'
// 这里存放项目所需要的工具方法
import { MessageBox } from 'element-ui'
/**
 * js 对象浅拷贝
 * @param {object} obj
 * @return {object}
 * @public
 */
export function pureJsonClone(obj) {
  return JSON.parse(JSON.stringify(obj))
}

/**
 * 移除js对象属性值为空的元素
 * 适用场景：服务端接口规定参数值为空时不传递该参数
 * @param {object} obj
 * @return {object}
 * @public
 */
export function removeObjEmptyProperty(obj) {
  for (let key in obj) {
    if (obj.hasOwnProperty(key) && (obj[key] === null || obj[key] === undefined || obj[key] === '')) {
      delete obj[key]
    }
  }
  return obj
}

/**
 * 将unix时间戳转换为 年-月-日 时:分:秒
 * @param {number} timestamp
 * @return {string}
 * @public
 */
export function unixTimestamp(timestamp) {
  if (timestamp !== null && timestamp !== '' && timestamp !== undefined) {
    timestamp = Number(timestamp)
    let date = new Date(timestamp)
    let Y = date.getFullYear()
    let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    let m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return `${Y}-${M}-${D}  ${h}:${m}:${s}`
  }
  return ''
}

export function formatTime(timestamp) {
  if (timestamp !== null && timestamp !== '' && timestamp !== undefined) {
    timestamp = Number(timestamp)
    let date = new Date(timestamp)
    let Y = date.getFullYear()
    let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    return `${Y}-${M}-${D}`
  }
  return ''
}

export function secondToDate(seconds) {
  let secondsN = Number(seconds)
  let h = Math.floor(secondsN / 3600)
  let m = Math.floor((secondsN / 60) % 60)
  let s = Math.floor(secondsN % 60)

  return h + intl.$t('小时') + m + intl.$t('分钟') + s + intl.$t('秒')
}

/**
 * 格式化远程状态参数
 * 1、字段存在时，判断附加单位是否存在，存在则显示字段值加单位, 不存在则直接显示字段值
 * 2、字段不存在，显示 '-'
 * @param {object} obj
 * @param {string} param
 * @param {string} pend 附加单位参数
 *
 */
export function formatParam(obj, param, pend) {
  if (obj.hasOwnProperty(param)) {
    return pend ? obj[param] + ' ' + pend : obj[param]
  } else {
    return '-'
  }
}

export function checkPassword(pwd) {
  if (
    /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-zA-Z]|[0-9]){8,16}$/.test(pwd)
  ) {
    return true
  } else {
    return false
  }
}

/**
 * confirmPopover(): 确认提醒模态弹窗
 * @param type{String} 提示类型
 * @param contentText{String} 提示字段
 * @param successFn{Function} 成功回调
 * @param failFn{Function} 失败回调
 */
export function confirmPopover(type, contentText, successFn, failFn) {
  MessageBox.confirm(contentText, intl.$t('温馨提示'), {
    confirmButtonText: intl.$t('确认'),
    cancelButtonText: intl.$t('取消'),
    type: type
  })
    .then(() => {
      successFn && successFn()
    })
    .catch(() => {
      failFn && failFn()
    })
}

export function uuidGenerator(len, radix) {
  let chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  let uuid = []
  let i
  radix = radix || chars.length
  len = len || 16

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
  } else {
    // rfc4122, version 4 form
    let r

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16)
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}

export function formatGroupPlatformList(plist) {
  let temp = [{ options: [] }, { options: [] }, { options: [] }, { options: [] }]

  plist.map(item => {
    if (item.platformId === 'xp-auth-admin') {
      temp[0]['options'].push(item)
    } else if (['xp-rmp', 'xp_vehicle', 'xp_card', 'xp-vim', 'xp_ota'].indexOf(item.platformId) !== -1) {
      temp[1]['options'].push(item)
    } else if (['xp-pay-admin', 'xp-ucm', 'xp-sns-admin'].indexOf(item.platformId) !== -1) {
      temp[2]['options'].push(item)
    } else {
      temp[3]['options'].push(item)
    }
  })
  return temp
}

export function getBrowserInfo() {
  let browserName = 'Unknown'

  if (typeof navigator === 'undefined') return { browser: browserName }

  let userAgent = navigator.userAgent

  // 常见的浏览器标识
  if (userAgent.match(/MSIE|Trident/)) {
    browserName = 'Internet Explorer'
  } else if (userAgent.match(/Firefox/)) {
    browserName = 'Firefox'
  } else if (userAgent.match(/Chrome/)) {
    browserName = 'Chrome'
  } else if (userAgent.match(/Safari/)) {
    browserName = 'Safari'
    // 区分Safari和Chrome，因为两者在Safari部分有相似的字符串
    if (userAgent.match(/Version\/[\d\.]+/)) {
      browserName += ' (WebKit)' // 表明是基于WebKit的浏览器，如Chrome或Safari
    }
  } else if (userAgent.match(/Opera|OPR/)) {
    browserName = 'Opera'
  } else if (userAgent.match(/Edge/)) {
    browserName = 'Edge'
  }

  return { browser: browserName }
}

export function loginCheckUid() {
  const cookie = document.cookie || ''
  return (cookie.match(/uid=/g) || []).length
}

export function getHostSpace() {
  const hostname = window.location.hostname
  if (hostname.includes('.cn-svw.')) {
    return 'svw'
  } else if (hostname.includes('.cn-fawvw.')) {
    return 'fawvw'
  } else if (hostname.includes('.cn-vwa.')) {
    return 'vwa'
  } else if (hostname.includes('.cn-vw.')) {
    return 'vw'
  }
  return ''
}

export function isHostTest() {
  const hostname = window.location.hostname
  return hostname.includes('.uat.') || hostname.includes('.dev.') || hostname.includes('.sit.')
}
